import useSearch from '@/hooks/app/useSearch';

import SearchResults from '../SearchResults';
import { SearchStyledLoader } from '../styles';
import { OnResultClick, SearchResultFilter } from '../types';

export interface Props {
	resultFilter: SearchResultFilter;
	onResultClick: OnResultClick;
	isInMsftMeeting?: boolean;
	query: string;
	selectedCategory: string[];
	selectedCategoryValue: string[];
	selectedDuration: string[];
	selectedDurationValue: string[];
}

const SearchBody: React.FC<Props> = ({
	resultFilter,
	onResultClick,
	isInMsftMeeting,
	query,
	selectedCategory,
	selectedCategoryValue,
	selectedDuration,
	selectedDurationValue,
}) => {
	const {
		isLoading: searchIsLoading,
		pack,
		usedFallback,
		query_id,
		search_index,
	} = useSearch(query, selectedCategory, selectedDuration);
	const packItems = pack?.items?.filter(resultFilter);

	if (searchIsLoading) {
		return <SearchStyledLoader />;
	}

	return (
		<SearchResults
			query={query}
			query_id={query_id}
			search_index={search_index}
			category={selectedCategoryValue}
			duration={selectedDurationValue}
			usedFallback={usedFallback}
			isInMsftMeeting={isInMsftMeeting}
			pack={pack}
			packItems={packItems}
			onResultClick={onResultClick}
		/>
	);
};

export default SearchBody;
